import type { PostCreationContext } from '@/features/post-editor/types/postCreationOptions';
import type { PostFeedType } from '@/features/posts/types/postFeed';

export const PostCreationRoute = {
  PostCreationHome: 'post-creation-home',
  PostCreationRegion: 'post-creation-region'
} as const;

export type PostCreationRoute =
  (typeof PostCreationRoute)[keyof typeof PostCreationRoute];

export type PostCreationParam = {
  [PostCreationRoute.PostCreationHome]: {
    channelType?: PostFeedType;
    groupId?: string;
    creationContext: PostCreationContext;
  };
  [PostCreationRoute.PostCreationRegion]:
    | { channelType?: PostFeedType }
    | undefined;
};
